import { useEffect, useState } from 'react';
import '../assets/css/mapa.css';
import '../assets/css/styles.css';
import seleccionador from '../assets/img/gif/_seleccionador.gif'
import progress from '../assets/img/gif/progres.gif'
import zd from '../assets/img/zd.png';
import zi from '../assets/img/zi.png';
import { Acerca } from '../funciones/mensajes.js'
import { Propio } from '../funciones/generales';
import { typeWriter } from '../funciones/typeWriter.js';
import logo from '../assets/img/logo_s.png';

var objSesion;

function acerca(mensaje, velocidad, fun) {
    setTimeout(() => {
        const elemento = document.getElementById('text_pergamino');
        typeWriter(elemento, mensaje, velocidad, function () {

        })
    }, 300);
}


function Mapa(props) {

    useEffect(() => {
        objSesion = JSON.parse(localStorage.getItem("session"));
        let usuario = objSesion.nombre;
        console.log(usuario)
        const root = document.getElementById("root_");
        const pergamino = document.getElementById("pergamino");
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        let posX = 50;
        let posY = 50;
        let stepX = 20;
        let stepY = 20;
        let stepOffset = 10;
        let isLeftFoot = true;


        function addFootprint(x, y, rotationDeg) {
            const shoe = document.createElement("img");
            shoe.classList.add("shoe")
            shoe.src = isLeftFoot ? zi : zd; // tus imágenes
            shoe.className = "footprint";
            shoe.style.left = x + "px";
            shoe.style.top = y + "px";
            shoe.style.transform = `rotate(${rotationDeg}deg)`;

            root.appendChild(shoe);

            // puntero solo cuando es pie izquierdo
            if (isLeftFoot) {
                const puntero = document.createElement("div");
                puntero.className = "puntero";
                puntero.style.left = (x - 95) + "px";
                puntero.style.top = (y - 120) + "px";

                const texto = document.createElement("span");
                puntero.classList.add("puntero")
                texto.classList.add("rage")
                texto.textContent = Propio(usuario.split(" ")[0]);
                puntero.appendChild(texto);

                root.appendChild(puntero);

                // Desvanecer
                setTimeout(() => puntero.style.opacity = 0, 800);
                setTimeout(() => root.removeChild(puntero), 1800);
            }

            // Desvanecer zapato
            setTimeout(() => shoe.style.opacity = 0, 800);
            setTimeout(() => root.removeChild(shoe), 1800);

            isLeftFoot = !isLeftFoot;
        }

        function startDiagonalWalk() {
            function step() {
                if (posY >= screenHeight) {
                    changeMap();
                    return;
                }

                let yOffset = isLeftFoot ? -stepOffset : stepOffset;
                let rotationDeg;

                if (posX < screenWidth / 2) {
                    rotationDeg = 45;
                    let xOff = isLeftFoot ? 25 : 0;
                    addFootprint(posX + xOff, posY + yOffset, rotationDeg);
                    posX += stepX;
                    posY += stepY;
                } else {
                    yOffset = isLeftFoot ? -stepOffset + 30 : stepOffset;
                    stepX = 40;
                    stepY = 1;
                    rotationDeg = 90;
                    let xOff = isLeftFoot ? 20 : -20;
                    posX = screenWidth / 2;
                    addFootprint(posX + xOff, posY + yOffset, rotationDeg);
                    posY += stepY * 40.5;
                }

                setTimeout(step, 700); // velocidad
                //setTimeout(step, 200); // velocidad
            }

            step();
        }

        function changeMap() {
            root.style.transition = "opacity 0.3s";
            root.style.opacity = 0;
            setTimeout(() => {
                root.style.opacity = 1;
                root.remove();
                pergamino.classList.toggle("hide")
                acerca("Hola " + Propio(usuario) + ", dejame contarte un poco de mi...<br> <br>" + Acerca(), 100, null)
            }, 300);
        }

        startDiagonalWalk();
    }, []);
    return (
        <div class="Mapa" id="">
            {<div id="root_">
                <div class="overlay"></div>
                <div class="logo-">
                    <img width={50} src={logo} class="logo-map"></img>
                </div>
            </div>
            }
            <div id="pergamino" class="hide">
                <div class="change rage">
                    <div id="text_pergamino" class="change-inside">

                    </div>
                </div>
            </div>

        </div>
    );
}

export default Mapa;